import { useState } from "react";

import { useImmer } from "use-immer";

import { ArrearsReportModal } from "@components/ArrearsReportModal";
import { Button } from "@components/Button";
import { Table } from "@components/Table";
import { LessonPaymentStatus } from "@constants/LessonPaymentStatus";
import { useChangeArrearStatus } from "@hooks/useChangeArrearStatus";
import { useStandaloneArrears } from "@hooks/useStandaloneArrears";
import { ReactComponent as FiltersImg } from "@img/filters.svg";
import { ReactComponent as ReportImg } from "@img/report.svg";
import { isSmallScreen } from "@utils/utils";

import { columns } from "./columns";
import { columnsMobile } from "./columnsMobile";
import { Filters } from "./Filters";
import { FiltersModal } from "./FiltersModal";

import cs from "./FinancesListPage.module.scss";

const FILTERS_INIT = {
  students: [],
  status: "all",
};

const DEFAULT_SORT = ["-updatedAt"];

export const FinancesListPage = () => {
  const [filters, setFilters] = useImmer<Record<string, any>>(FILTERS_INIT);
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  const [sort, handleSort] = Table.useSort(DEFAULT_SORT);
  const [pagination, setPagination] = Table.usePagination();

  const { data = [], isLoading } = useStandaloneArrears(
    filters,
    sort,
    pagination,
  );
  const changeStatus = useChangeArrearStatus();

  return (
    <main className={cs.page}>
      <header className={cs.header}>
        {/* TODO: Later */}
        {/*<Button color="primary">*/}
        {/*  <EmailImg width={14} />*/}

        {/*  <span>Przypomnij o płatności</span>*/}
        {/*</Button>*/}
        <Button
          color="neutral"
          className="ml10"
          onClick={() => setIsReportModalOpen(true)}
        >
          <ReportImg height={14} />

          <span>Generuj raport</span>
        </Button>
        <div className={cs.openFiltersBtn}>
          <Button
            color="neutral"
            type="outlined"
            className="hide-desktop-up mr-auto ml12"
            onClick={() => setFiltersModalOpen(true)}
          >
            <FiltersImg width={12} />
            <span>Filtruj</span>
          </Button>
        </div>
      </header>

      <Filters
        filters={filters}
        onChange={handleFilterChanged}
        onClear={handleClearFilters}
      />

      <section className={cs.table}>
        <Table
          data={data}
          sort={sort}
          pagination={pagination}
          columns={(isSmallScreen ? columnsMobile : columns)({
            onStatusChange: handleStatusChanged,
          })}
          isLoading={isLoading}
          onSort={handleSort}
          onPaginationChange={setPagination}
        />
      </section>

      <FiltersModal
        isOpen={filtersModalOpen}
        filters={filters}
        onChange={handleFilterChanged}
        onClear={handleClearFilters}
        onClose={() => setFiltersModalOpen(false)}
      />

      <ArrearsReportModal
        isOpen={isReportModalOpen}
        onClose={() => setIsReportModalOpen(false)}
      />
    </main>
  );

  function handleFilterChanged(filterKey: string, value: any) {
    setFilters((prev: any) => void (prev[filterKey] = value));
    resetPagination();
  }

  function handleStatusChanged(arrearId: string, status: LessonPaymentStatus) {
    changeStatus.mutate({ arrearId, status });
  }

  function handleClearFilters() {
    setFilters(FILTERS_INIT);
    resetPagination();
  }

  function resetPagination() {
    setPagination({ page: 1, pageSize: pagination.pageSize });
  }
};
